<template>
  <Dialog
        :header="`Crop Image`"
  :visible.sync="showChangeCarDialog"
  :modal="true"
  class="cropper-dialog"
  :style="{ width: '90vw', height: '90%' }">
    <!-- :contentStyle="{ maxHeight: '80vh', overflowY: 'auto' }" -->
    <!-- GÁN CROP    -->
     <div class="cropper-wrapper">
     <cropper
          ref="cropper"
          class="cropper"
          :src="imageSrc"
          :stencil-props="{ aspectRatio: 1 }"
          @change="onCrop"
        />
     </div>
    <template #footer>

      <Button
          label="Cancel"
          @click="showChangeCarDialog = false"
          icon="pi pi-times"
          class="p-button-warning"
      />
      <Button
          label="Confirm"
          @click="getCroppedImage"
          icon="pi pi-check"
          class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
      />
    </template>
    </Dialog>
</template>

<script>

import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

export default {
  components: {
    Cropper
  },
  props: {
    //OBJECT
    //items: Array,
    imageSrc: String,
  },
  data() {
    return {
      showChangeCarDialog: true,
      croppedImage: null,
      
    }
  },
  created() {
     this.$commonFuction.is_loading(true);
    // console.log("this.contentSetthis.contentSet",this.contentSet);
   // this.formData.content = this.contentSet;
   setTimeout(() => {
     this.$commonFuction.is_loading(false);
   }, 1500);
  },
  watch: {
   

  },
  // watch: {
  //   '$route': 'initParams'
  // },
  methods: {
   onCrop({ coordinates, canvas }) {
      console.log(coordinates, canvas)
      this.croppedImage = canvas.toDataURL();
    },
    getCroppedImage() {
      this.$commonFuction.is_loading(true);
      const { canvas } = this.$refs.cropper.getResult();
      this.croppedImage = canvas.toDataURL();
      this.showChangeCarDialog = false;
       let blob = this.dataURLtoBlob(this.croppedImage);

    // Tạo đối tượng File
    let file = new File([blob], "cropped-image.png", { type: blob.type });
    file.source = file;
    file.objectURL = window.URL.createObjectURL(file);
    this.$emit('cropped-image', file);
    setTimeout(() => {
     this.$commonFuction.is_loading(false);
   }, 1000);
    },
    dataURLtoBlob(dataURL) {
    let arr = dataURL.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
  },
}
</script>
<style lang="scss">
.cropper-dialog {
  .p-dialog-content {
    height: 100vh; /* Đảm bảo nội dung popup không bị tràn */
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.cropper-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cropper {
  width: 400px;
  height: 100%; /* Tăng chiều cao */
  max-height: 100vh; /* Giới hạn chiều cao theo màn hình */
  object-fit: contain;
  border: 1px solid #ddd;
}



</style>